import { Component } from '@angular/core';

@Component({
  selector: 'palantir-layout',
  standalone: true,
  imports: [],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class PalantirLayoutComponent {}
